import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificationRealtimeService {
    public data: any;
    public bradcastedData: any[];
    private hubConnection: signalR.HubConnection

    constructor(private http: HttpClient) { }

    public startNotificationServices(userId: string) {
        this.startConnection();
        this.addTransferNotificaionDataListener(userId);
        this.addBroadcastNotificationDataListener(userId);
        this.http.get(`${environment.realTimeAPIRoot}/api/notify/${userId}`)
        .subscribe(res => {
        })
    }

    public startConnection = () => {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${environment.realTimeAPIRoot}/notify`)
            .withAutomaticReconnect()
            .build();

        this.hubConnection
            .start()
            .catch(err => console.log('Error starting notification connection: ' + err))
    }

    public addTransferNotificaionDataListener = (userId) => {
        this.hubConnection.on(`transfernotification-${userId}`, (data) => {
            this.data = data;
            // Console.log(data);
        });
    }

    public broadcastNotifiationData = (userId) => {
        this.hubConnection.invoke(`bcnotification-${userId}`, this.data)
            .catch(err => console.error(err));
    }

    public addBroadcastNotificationDataListener = (userId) => {
        this.hubConnection.on(`bcnotification-${userId}`, (data) => {
            this.bradcastedData = data;
        })
    }

    public stopConnection() {
        this.hubConnection.stop()
    }

}